import { useNavigate } from '@tanstack/react-router'
import { useLogin } from '@/hooks/api/useAuth'
import { LoginForm } from '@/components/features/shared/LoginForm'
import { LoginCredentials, canAccessManagement } from '@/domain/auth/auth'
import { Paths } from '@/routes/paths'
import { useToast } from '@/hooks/use-toast'

export const ManagementLogin = () => {
  const navigate = useNavigate()
  const { toast } = useToast()

  const loginMutation = useLogin('management', (user) => {
    // Handle navigation after successful login
    if (canAccessManagement(user)) {
      navigate({ to: `${Paths.Management.Dashboard}` })
    } else {
      toast({
        title: "Acceso Denegado",
        description: "No tienes permisos para acceder al panel de administración.",
        variant: "destructive",
      })
    }
  })

  const handleLogin = (credentials: LoginCredentials) => {
    loginMutation.mutate(credentials)
  }

  const handleForgotPassword = () => {
    // navigate({ to: Paths.ForgotPassword })
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Solar del Río</h1>
          <p className="text-lg text-gray-600">Panel de Administración</p>
        </div>

        <LoginForm
          onSubmit={handleLogin}
          isLoading={loginMutation.isPending}
          title="Iniciar Sesión"
          description="Accede al panel de administración con tus credenciales"
          onForgotPassword={handleForgotPassword}
        />
      </div>
    </div>
  )
}
